import React from 'react';
import {connect} from 'react-redux';
import {changeInput} from "../lib/actions";
import {MAX_NECKLACE_LETTERS_PER_LINE, NECKLACE} from "../../constants";

class InputHeader extends React.Component {
    getDescription(orientation) {
        switch (orientation) {
            case NECKLACE.STANDARD:
                return 'Up to ten characters joined on a chain.';
            case NECKLACE.SPACED:
                return 'Up to ten characters spaced on chain.';
            case NECKLACE.SIDEWAYS:
                return 'Up to ten sideways characters spaced on chain.';
            case NECKLACE.VERTICAL:
                return 'Up to ten vertically stacked characters on a chain.';
        }
    }

    render() {
        return (
            <div className="customizer__header">
                <h4>
                    {this.props.orientation.description} Text
                </h4>
                <p>{this.getDescription(this.props.orientation)}</p>
            </div>
        );
    }
}

class Input extends React.Component {
    onChange(value) {
        if (/[^a-zA-Z0-9&]/.test(value)) {
            return;
        }

        if (value.length && value.length > MAX_NECKLACE_LETTERS_PER_LINE) {
            return;
        }

        this.props.onChange(value.toUpperCase());
    }

    render() {
        let counterClassName = 'customizer-input__count';

        if (!this.props.input || this.props.input.length === 0) {
            counterClassName += ' customizer-input__count-error';
        }

        return (
            <>
                <InputHeader orientation={this.props.orientation}/>
                <div className='customizer-input'>
                    <div className="customizer-input__line">
                        <input className='customizer-input__field' type='text' value={this.props.input} onChange={(e) => this.onChange(e.target.value)}/>
                        <div className={counterClassName}>{this.props.input ? this.props.input.length : 0}/{MAX_NECKLACE_LETTERS_PER_LINE}</div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input,
        orientation: state.necklaceOrientation,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (input) => {
            dispatch(changeInput(input));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
